module.exports = [{
      plugin: require('/vercel/17791f6a/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
